import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  firstGrid: {
    margin: "0 -24px 32px -32px",
    width: "calc(100% + 48px)"
  }
}));
